import { useEffect, useState } from "react";

export const useCache = <T>(value: T | undefined): T | undefined => {
  const [cached, setCached] = useState<T | undefined>(value);
  useEffect(() => {
    if (value === undefined) return;
    setCached(value);
  }, [value]);
  return cached;
};
